import cn from 'classnames';
import React, { useState } from 'react';

export default ({
  reference,
  index = 0,
  isSelected = false,
  onClick = () => {},
}) => {
  const [number] = useState(index + 1);
  return (
    <button
      className={cn('all-overview-icons__icon', {
        'is-selected': isSelected,
      })}
      onClick={(e) => onClick(e, reference)}
    >
      {number}
    </button>
  );
};
